import { render, staticRenderFns } from "./CustomerPartnerCreateDetail.vue?vue&type=template&id=1d981e4c"
import script from "./CustomerPartnerCreateDetail.vue?vue&type=script&lang=js"
export * from "./CustomerPartnerCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerPartnerCreateDetail.vue?vue&type=style&index=0&id=1d981e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports